import { render } from "./ViewArtist.vue?vue&type=template&id=9db33c9a&scoped=true"
import script from "./ViewArtist.vue?vue&type=script&lang=js"
export * from "./ViewArtist.vue?vue&type=script&lang=js"

import "./ViewArtist.vue?vue&type=style&index=0&id=9db33c9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db33c9a"]])

export default __exports__